<template>
  <BaseDialog
    :title="$t('kachogawaPickupOverview.dialog.editNote.title')"
    width="480px"
    :btn1Loading="submitting"
    :btn1Disabled="submitting"
    @confirm="onConfirm"
    @close="$emit('close')"
  >
    <BaseElForm label-position="top" :model="formData" class="edit-note-form">
      <BaseElFormItem :label="$t('kachogawaPickupOverview.dialog.note.title')">
        <BaseElInput
          v-model="formData.adminComment"
          type="textarea"
          :rows="4"
          :maxlength="500"
          show-word-limit
          :placeholder="$t('kachogawaPickupOverview.dialog.notePrompt.text')"
        />
      </BaseElFormItem>
    </BaseElForm>
  </BaseDialog>
</template>

<script>
import { defineComponent, reactive, ref } from 'vue'
import { get } from 'lodash'
import BaseDialog from '@/components/Dialog/BaseDialog.vue'
import { i18n } from '@/plugins/i18n/i18n'
import { UpdateReservationOrderInfo } from '@/api/reservation'
import { useTable } from '@/use/table'

export default defineComponent({
  name: 'EditAdminCommentDialog',
  components: { BaseDialog },
  props: {
    reservation: {
      type: Object,
      required: true,
    },
  },
  emits: ['close', 'updated'],
  setup (props, { emit }) {
    const { shopId } = useTable()
    const submitting = ref(false)
    const originalComment = get(props.reservation, 'AppointmentOrder.adminComment', '') || ''
    const formData = reactive({
      adminComment: originalComment,
    })

    const onConfirm = async () => {
      // 內容未變更不送 API，直接關閉
      if (formData.adminComment === originalComment) {
        emit('close')
        return
      }
      submitting.value = true
      const [, err] = await UpdateReservationOrderInfo({
        shopId: shopId.value,
        id: get(props.reservation, 'AppointmentOrder.id'),
        adminComment: formData.adminComment,
      })
      submitting.value = false
      if (err) return window.$message.error(err)
      window.$message.success(i18n.t('common.message.updateSuccess'))
      emit('updated')
      emit('close')
    }

    return { formData, submitting, onConfirm }
  },
})
</script>

<style lang="postcss" scoped>
.edit-note-form {
  @apply w-full;
}

.edit-note-form :deep(.el-form-item),
.edit-note-form :deep(.el-textarea),
.edit-note-form :deep(.el-textarea__inner) {
  @apply w-full;
}
</style>
